import { bool, not, reads } from '@ember/object/computed';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import Controller from '@ember/controller';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestController extends Controller {
  @service currentPractice;
  @service session;

  @reads('currentPractice.useBookAppointmentLanguage') useBookAppointmentLanguage;

  @bool('session.currentClient') isSignedIn;
  @not('isSignedIn') isNotSignedIn;
  @computed('activeSteps.@each.isActive')
  get isFirstStep() {
    return this.activeSteps?.at(0)?.isActive;
  }
}
